// @flow
import * as React from 'react';
import styled from "styled-components";
import colors from '../../../assets/css/colors';
import {
	FormGroup,
	ButtonSecondary,
} from "../../../components";
import Tick from '../../../components/Icons/Tick';

const FormGroupStyled = styled(FormGroup)`
	display: flex;
	justify-content: center;
	padding-bottom: 2.5em;
	position: relative;
	button{
		flex-basis: 45%;
	}
	
	input{
		flex-basis: 45%;
	
		&:disabled {
			opacity: .5;
			margin-left: 0;
		}
	}
`;

const CopiedMessage = styled.div`
	color: ${colors.nrlGreen};
	position: absolute;
	font-size: 19px;
	left: 75%;
	display: flex;
	align-items: baseline;
	> div {
		margin-left: 3px;
	}
`;

type Props = {
	handleCopy: Function,
	show_success: boolean
}
export const LeaguePin = ({ handleCopy, show_success }: Props) => (
	<div>
		<FormGroupStyled>
			<ButtonSecondary onClick={handleCopy}>Copy PIN number</ButtonSecondary>
			{show_success ?
				<CopiedMessage>
					<Tick/>
					<div>
						Code copied!
					</div>
				</CopiedMessage>
				: null}
		</FormGroupStyled>
	</div>
);

export default LeaguePin;


// WEBPACK FOOTER //
// ./src/pages/league/invites/leaguePin.js